import { render, staticRenderFns } from "./DoughnutOrder.vue?vue&type=template&id=fa26af7e&scoped=true&"
import script from "./DoughnutOrder.vue?vue&type=script&lang=js&"
export * from "./DoughnutOrder.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutOrder.vue?vue&type=style&index=0&id=fa26af7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa26af7e",
  null
  
)

export default component.exports